import { getData } from '../../../../utils/api'
import { useEffect, useState } from 'react';
import { Footers } from '../../../Footers'
import { CloseOutline, UnorderedListOutline } from 'antd-mobile-icons'

import { Swiper, Popup } from 'antd-mobile'

import { SWIPER, PART_FOUR_ITEMS, MEDIAS, NAV_ITEMS } from '../../../HomePage/consts'

import './index.css'
import { getApi } from "../../../../utils/getApi";

export const ReportBox = ({ activePage, setActivePage }) => {

    const [isShowPopup, setIsShowPopup] = useState(false)
    const [path, setPath] = useState('');


    useEffect(() => {
        setPath(getApi)
        const searchParams = new URLSearchParams(window.location.search.split('?')[1]);
        const params = {};

        for (const [key, value] of searchParams.entries()) {
            params[key] = value;
        }
        console.log(params);
        if (params.onlinecode) {
            getYanzeng()
        } else {
            getList()

        }

    }, []);

    const formatDateString = (dateStr) => {
        // 检查输入是否为 null 或 undefined
        if (dateStr == null) {
            return dateStr; // 或返回默认值，如空字符串 ''
        }

        if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
            return dateStr.replace(/(\d{4})-(\d{2})-(\d{2})/, '$1年$2月$3日');
        }
        return dateStr;
    }

    const [dataSource, setDataSource] = useState({});
    const getList = async () => {
        const res = await getData('/api/user/zhengshu', 'post')
        if (res.data.code == 1) {
			console.log('类型');
			console.log(window.localStorage.getItem('status'));
            if (window.localStorage.getItem('status')=='twoxj') {
                res.data.data[0].enrollment_time = res.data.data[0].sec_enrollment_time
                res.data.data[0].graduation_time = res.data.data[0].sec_graduation_time
                res.data.data[0].school_name = res.data.data[0].sec_school_name
                res.data.data[0].zhuanye = res.data.data[0].sec_zhuanye
                res.data.data[0].xuezhi = res.data.data[0].sec_xuezhi
                res.data.data[0].xueli_level = res.data.data[0].sec_xueli_level
                res.data.data[0].leibie = res.data.data[0].sec_leibie
                res.data.data[0].xingshi = res.data.data[0].sec_xingshi
                res.data.data[0].is_biye = res.data.data[0].sec_is_biye
                res.data.data[0].certificate_number = res.data.data[0].sec_certificate_number
                res.data.data[0].rector = res.data.data[0].sec_rector
                res.data.data[0].online_code = res.data.data[0].sec_online_code
            } else if( window.localStorage.getItem('status')=='threexj') {
				res.data.data[0].enrollment_time = res.data.data[0].thr_enrollment_time
				res.data.data[0].graduation_time = res.data.data[0].thr_graduation_time
				res.data.data[0].school_name = res.data.data[0].thr_school_name
				res.data.data[0].zhuanye = res.data.data[0].thr_zhuanye
				res.data.data[0].xuezhi = res.data.data[0].thr_xuezhi
				res.data.data[0].xueli_level = res.data.data[0].thr_xueli_level
				res.data.data[0].leibie = res.data.data[0].thr_leibie
				res.data.data[0].xingshi = res.data.data[0].thr_xingshi
				res.data.data[0].is_biye = res.data.data[0].thr_is_biye
				res.data.data[0].certificate_number = res.data.data[0].thr_certificate_number
				res.data.data[0].rector = res.data.data[0].thr_rector
				res.data.data[0].online_code = res.data.data[0].thr_online_code
				
			}
            setDataSource(res.data.data[0]);
        }
    }

    const getYanzeng = async () => {

        const searchParams = new URLSearchParams(window.location.search.split('?')[1]);
        const params = {};

        for (const [key, value] of searchParams.entries()) {
            params[key] = value;
        }
        console.log(params);

        const res = await getData('/api/user/yanzheng', 'post', {
            online_code: params.onlinecode,
            username: params.id
        })
        if (res.data.code == 1) {
            console.log(res.data.data[0].sec_online_code);
            console.log(window.location.search.split('?onlinecode=')[1]);

            if (window.location.search.split('?onlinecode=')[1] == res.data.data[0].sec_online_code) {
                res.data.data[0].enrollment_time = res.data.data[0].sec_enrollment_time
                res.data.data[0].graduation_time = res.data.data[0].sec_graduation_time
                res.data.data[0].school_name = res.data.data[0].sec_school_name
                res.data.data[0].zhuanye = res.data.data[0].sec_zhuanye
                res.data.data[0].xuezhi = res.data.data[0].sec_xuezhi
                res.data.data[0].xueli_level = res.data.data[0].sec_xueli_level
                res.data.data[0].leibie = res.data.data[0].sec_leibie
                res.data.data[0].xingshi = res.data.data[0].sec_xingshi
                res.data.data[0].is_biye = res.data.data[0].sec_is_biye
                res.data.data[0].certificate_number = res.data.data[0].sec_certificate_number
                res.data.data[0].rector = res.data.data[0].sec_rector
                res.data.data[0].online_code = res.data.data[0].sec_online_code
            }
            setDataSource(res.data.data[0]);
        }
    }

    const navContent = () => {
        return (
            <div className='my-nav'>
                {NAV_ITEMS.map(item => {
                    return (<div className='nav-items'>
                        {item.map(e => {
                            return (
                                <div className="nav-items-item" key={e.key}>
                                    <a href={e.hrefUrl}>{e.text}</a>
                                </div>
                            )
                        })}
                    </div>)
                })}</div>
        )
    }

    const times = (v) => {
        if (!v) return '';

        let timestamp;

        // 1. 处理纯数字（可能已经是时间戳）
        if (typeof v === 'number' || /^\d+$/.test(v)) {
            const numValue = Number(v);
            // 判断是否是毫秒时间戳（13位）还是秒时间戳（10位）
            if (numValue < 10000000000) {
                // 秒级时间戳，转换为毫秒
                timestamp = numValue * 1000;
            } else {
                // 毫秒级时间戳
                timestamp = numValue;
            }
        }
        // 2. 处理 "2026年01月24日" 这种中文格式 - 直接返回
        else if (typeof v === 'string' && v.includes('年') && v.includes('月') && v.includes('日')) {
            // 已经是中文格式，尝试提取并标准化
            const match = v.match(/(\d{4})年(\d{1,2})月(\d{1,2})日/);
            if (match) {
                const [, year, month, day] = match;
                // 直接格式化为标准中文格式
                return `${year}年${month.padStart(2, '0')}月${day.padStart(2, '0')}日`;
            } else {
                // 如果匹配失败，尝试用Date解析
                timestamp = new Date(v).getTime();
            }
        }
        // 3. 处理其他格式的日期字符串
        else if (typeof v === 'string') {
            // 尝试用Date对象解析
            timestamp = new Date(v).getTime();

            // 如果解析失败，Date会返回Invalid Date，getTime()会返回NaN
            if (isNaN(timestamp)) {
                // 尝试处理一些特殊格式
                // 比如 "2026-01-24" 或 "2026/01/24"
                const cleanedStr = v.replace(/\//g, '-');
                timestamp = new Date(cleanedStr).getTime();
            }
        } else {
            // 其他情况，直接尝试用Date对象解析
            timestamp = new Date(v).getTime();
        }

        // 检查时间戳是否有效
        if (isNaN(timestamp)) {
            console.warn(`无法解析的时间格式: ${v}`);
            return '';
        }

        // 格式化日期
        const date = new Date(timestamp);

        // 再次验证日期是否有效
        if (isNaN(date.getTime())) {
            console.warn(`无效的时间戳: ${timestamp}，原始值: ${v}`);
            return '';
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        // 统一返回中文格式 "YYYY年MM月DD日"
        return `${year}年${month}月${day}日`;
    }
    return (
        <div className='bacscs'>
            <div className="wap-nav-bar"><div className="wap-nav-bar__left">
                <div >
                    <a href="/">
                        <img src="https://t3.chei.com.cn/chsi/assets/gb/wap/images/logo.png" alt="学信网" className="logo" />

                    </a>
                </div> <span className="logo-dot">

                </span> <span className="logo-text"><a href="/xlcx/bgcx.jsp">在线验证

                </a>

                </span>

            </div> <div className="wap-nav-bar__center">

                </div> <div className="wap-nav-bar__right"><span className="ch-nav">
                    <div className="wap-nav-bar__right" style={{ padding: '0' }} onClick={() => setIsShowPopup(true)}>
                        <span className="ch-nav"><UnorderedListOutline /></span>
                    </div>


                </span>

                </div>

            </div>
            <div className="res-wrap"><div className="card"><div className="top-change"><div className="lang-div">
                报告语种
                <a href="javascript:;" className="current">中文
                </a><a href="javascript:;">英文
                </a>
            </div> 
			<div title="下载PDF" onClick={() => {
				window.location.href='/report/Xuelidown?vcode=ACZVDTBE6G03X3XY&amp;rid=53147208248462509361002610768517&amp;ln=cn'
				}} className="pdf-div">
			</div>
            </div>  <h3 className="res-h3">教育部学历证书电子注册备案表
                </h3> <div className="img-div"><img src={`${path}${dataSource.avatar}`} width="58" data-caption="个人头像" />
                </div> <div className="rowcard"><div className="row"><div className="col-left">姓名
                </div><div className="col-right namtFamily">{dataSource.username}
                    </div>
                </div> <div className="row"><div className="col-left">性别
                </div><div className="col-right">{dataSource.gender == 0 ? '女' : '男'}
                        </div>
                    </div> <div className="row"><div className="col-left">出生日期
                    </div><div className="col-right">{dataSource.birthday}
                        </div>
                    </div>
                    <div className="row"><div className="col-left">入学日期
                    </div><div className="col-right">{formatDateString(dataSource.enrollment_time)}
                        </div>
                    </div> <div className="row"><div className="col-left">毕(结)业日期
                    </div><div className="col-right">{formatDateString(dataSource.graduation_time)}
                        </div>
                    </div> <div className="row"><div className="col-left">学校名称
                    </div><div className="col-right">{dataSource.school_name}
                        </div>
                    </div> <div className="row"><div className="col-left">专业
                    </div><div className="col-right">{dataSource.zhuanye}
                        </div>
                    </div> <div className="row"><div className="col-left">学制
                    </div><div className="col-right">{dataSource.xuezhi}
                        </div>
                    </div> <div className="row"><div className="col-left">层次
                    </div><div className="col-right">{dataSource.xueli_level}
                        </div>
                    </div> <div className="row"><div className="col-left">学历类别
                    </div><div className="col-right">{dataSource.leibie}
                        </div>
                    </div> <div className="row"><div className="col-left">学习形式
                    </div><div className="col-right">{dataSource.xingshi}
                        </div>
                    </div> <div className="row"><div className="col-left">毕(结)业
                    </div><div className="col-right">{dataSource.is_biye == 0 ? '结业' : '毕业'}
                        </div>
                    </div> <div className="row"><div className="col-left">证书编号
                    </div><div className="col-right">{dataSource.certificate_number}
                        </div>
                    </div> <div className="row"><div className="col-left">校(院)长姓名
                    </div><div className="col-right">{dataSource.rector}
                        </div>
                    </div> <div className="row"><div className="col-left">在线验证码
                    </div><div className="col-right">{dataSource.online_code}
                        </div>



                    </div> <div className="row"><div className="col-left">更新日期
                    </div><div className="col-right">{times(dataSource.updatetime)}
                        </div>
                    </div>
                </div>
            </div>
            </div>

            <Footers />
            {/* 导航弹出层 */}
            {isShowPopup && (<Popup
                visible={isShowPopup}
                onMaskClick={() => {
                    setIsShowPopup(false)
                }}
                onClose={() => {
                    setIsShowPopup(false)
                }}
                position='top'
                bodyStyle={{ height: '' }}
            >
                <div className="my-close-bar">
                    <a href="/wap/">
                        <img src="https://t3.chei.com.cn/chsi/assets/gb/wap/images/logo.png" alt="学信网" className="my-logo" />
                    </a>
                    <CloseOutline onClick={() => setIsShowPopup(false)} />
                </div>
                {navContent()}
            </Popup>)}
        </div >
    )
}